import React, { useEffect, useRef } from 'react';
import { MapContainer, TileLayer, GeoJSON, CircleMarker, Tooltip, ZoomControl } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const COLOR_HEX = {
  blue:    '#2563EB',
  emerald: '#059669',
  orange:  '#EA580C',
  violet:  '#7C3AED',
  red:     '#DC2626',
  yellow:  '#D97706',
};

// Bounds do Brasil para fitBounds fixo
const BRASIL_BOUNDS = [
  [-33.75, -73.99], // SW
  [5.27,   -34.79], // NE
];

const stateStyle = {
  color: '#93C5FD',
  weight: 1,
  fillColor: '#DBEAFE',
  fillOpacity: 0.6,
};

const onEachState = (feature, layer) => {
  const name = feature.properties?.sigla || feature.properties?.name || '';
  if (name) {
    layer.bindTooltip(name, {
      permanent: true,
      direction: 'center',
      className: 'state-label',
    });
  }
};

const BrasilMap = ({ pins = [] }) => {
  const mapRef = useRef(null);
  const [geoData, setGeoData] = React.useState(null);

  useEffect(() => {
    fetch('https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson')
      .then(r => r.json())
      .then(setGeoData)
      .catch(() => {});
  }, []);

  const validPins = pins.filter(p => p.lat != null && p.lng != null);

  return (
    <>
      <style>{`
        .state-label {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          font-size: 9px !important;
          font-weight: 700 !important;
          color: #3B82F6 !important;
          white-space: nowrap;
        }
        .state-label::before { display: none !important; }
        .leaflet-control-zoom { display: none !important; }
        .leaflet-control-attribution { display: none !important; }
      `}</style>
      <div
        className="w-full rounded-xl overflow-hidden shadow-sm border border-gray-200"
        style={{ height: 480, position: 'relative', zIndex: 0 }}
      >
        <MapContainer
          ref={mapRef}
          center={[-13, -52]}
          zoom={4}
          minZoom={4}
          maxZoom={4}
          scrollWheelZoom={false}
          dragging={false}
          touchZoom={false}
          doubleClickZoom={false}
          boxZoom={false}
          keyboard={false}
          zoomControl={false}
          attributionControl={false}
          style={{ height: '100%', width: '100%' }}
        >
          {/* Fundo branco puro — sem tiles externos */}
          <TileLayer
            url="https://{s}.basemaps.cartocdn.com/light_nolabels/{z}/{x}/{y}{r}.png"
          />

          {/* Estados do Brasil */}
          {geoData && (
            <GeoJSON
              data={geoData}
              style={stateStyle}
              onEachFeature={onEachState}
            />
          )}

          {/* Pins dos casos */}
          {validPins.map((pin, i) => {
            const color = COLOR_HEX[pin.color] || COLOR_HEX.blue;
            return (
              <CircleMarker
                key={i}
                center={[pin.lat, pin.lng]}
                radius={12}
                pane="markerPane"
                pathOptions={{
                  color: 'white',
                  weight: 3,
                  fillColor: color,
                  fillOpacity: 1,
                }}
              >
                <Tooltip
                  direction="top"
                  offset={[0, -12]}
                  opacity={1}
                >
                  <span style={{ fontSize: 12, fontWeight: 600, color: '#1e293b' }}>
                    {pin.title}
                  </span>
                </Tooltip>
              </CircleMarker>
            );
          })}
        </MapContainer>
      </div>
    </>
  );
};

export default BrasilMap;
